/* eslint-disable global-require */
import Vue from 'vue';
import VueAuth from '@d0whc3r/vue-auth-plugin';
import router from '@router/router';

const options = {
  authMeta: 'auth',
  rolesVar: 'permissions',
  tokenDefaultName: 'default_auth_token',
  userDefaultName: 'default_auth_user',
  tokenStore: ['localStorage', 'vuex'],
  headerTokenReplace: '{auth_token}',
  tokenType: 'Bearer',
  vuexStoreSpate: 'vue_auth',
  authRedirect: '/login',
  loginData: {
    url: 'auth/adminLogin',
    method: 'POST',
    redirect: 'admin.dashboard',
    headerToken: 'Authorization',
    fetchUser: true,
    customToken: (response) => response.data.token
  },
  logoutData: {
    url: 'auth/logout',
    method: 'DELETE',
    redirect: '/',
    makeRequest: true
  },
  fetchItem: 'user',
  fetchData: {
    url: 'auth/user',
    method: 'GET',
    interval: 30,
    enabled: true
  }
};

Vue.use(VueAuth, options);

Vue.$auth.logout = function logout() {
  const { url } = this.options.logoutData;
  const { method } = this.options.logoutData;
  const { redirect } = this.options.logoutData;
  const axios = require('./axios').default;
  axios({
    url: axios.defaults.baseURL + url,
    method,
    headers: {
      Authorization: `Bearer ${this.storeManager.getToken()}`
    }
  }).finally(() => {
    this.storeManager.resetAll();
    localStorage.removeItem('refresh_token');
    if (redirect) {
      router.push(redirect || '/');
    }
  });
};

Vue.$auth.storeManager.check = function check(role) {
  if (role) {
    const roles = this.getRoles();
    if (!roles) {
      return false;
    }
    if (Array.isArray(role)) {
      return role.every((authrole) => roles.includes(authrole));
    }
    return roles.includes(role);
  }
  return !!this.getToken();
};

export default Vue.$auth;
